function getQueryParam(queryString: string, paramName: string): string | null {
    // const queryString = window.location.search;
    const params = new URLSearchParams(queryString);
    return params.get(paramName);
}

export default getQueryParam;